class Drawer extends HTMLElement {
    constructor() {
        super();
        
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        document.querySelectorAll('.drawer__overlay').forEach(function(overlay) { overlay.addEventListener('click', this.close.bind(this)); }, this);
        this.setIconAccessibility();
        this.isMenu = this.isMenuDrawer();

        if(this.isMenu) {
          this.mainDetailsToggle = this.querySelector('details');
          if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
          this.addEventListener('keyup', this.onKeyUp.bind(this));
          this.addEventListener('focusout', this.onFocusOut.bind(this));
          this.bindEvents();
        }
        this.onLogin();
    }

    onLogin() {
      const allForms = document.querySelectorAll('#customer_login');
      if (allForms && allForms.length > 0) {
        allForms.forEach(form => {
          form.addEventListener('submit', (evt) => {
            let email = form.querySelector('#CustomerEmail').value;
            let returnTo = form.querySelector('[name="return_to"]');
            returnTo.value = '/account/?utm_email=' + email;
          })
        })
      }
    }

    isMenuDrawer() {
      const drawerName = this.getAttribute("data-drawer");
      return drawerName == "menu" ? true : false;
    }

    setIconAccessibility() {
      const links = document.querySelectorAll(`.icon-bubble`);
      links.forEach(function(link) {
        link.setAttribute('role', 'button');
        link.setAttribute('aria-haspopup', 'dialog');
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const drawerToOpen = link.getAttribute("data-open");
          const drawer = document.querySelector(`[data-drawer="${ drawerToOpen }"]`);
          this.open(link, drawer);
        });
        link.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            this.open(link);
          }
        });
      }, this);
    }

    open(triggeredBy, drawer = this) {
        if (triggeredBy) drawer.setActiveElement(triggeredBy);
        const drawerNote = drawer.querySelector('[id^="Details-"] summary');
        if (drawerNote && !drawerNote.hasAttribute('role')) drawer.setSummaryAccessibility(drawerNote);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => { drawer.classList.add('animate', 'active') });
  
        drawer.addEventListener('transitionend', () => {
        const containerToTrapFocusOn = drawer.classList.contains('is-empty') ? drawer.querySelector('.drawer__inner-empty') : drawer.querySelector('.drawer-wrapper');
        const focusElement = drawer.querySelector('.drawer__inner') || drawer.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      }, { once: true });
  
      document.body.classList.add('overflow-hidden');

    }

    close() {
        document.querySelectorAll("drawer-component").forEach((drawer) => {
          drawer.classList.remove('active');
        });
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility(drawerNote) {
        drawerNote.setAttribute('role', 'button');
        drawerNote.setAttribute('aria-expanded', 'false');
    
        if(drawerNote.nextElementSibling.getAttribute('id')) {
          drawerNote.setAttribute('aria-controls', drawerNote.nextElementSibling.id);
        }
    
        drawerNote.addEventListener('click', (event) => {
          event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        });
    
        drawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderContents(parsedState) {
      this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        sectionElement.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
  
      setTimeout(() => {
        this.querySelector('.drawer__overlay').addEventListener('click', this.close.bind(this));
        if (!document.querySelector('.fs-added-notification'))
           this.open();
      });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      selector = ".shopify-section"
      return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer'
        },
        {
          id: 'cart-icon-bubble'
        }
      ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector);
    }
    
    setActiveElement(element) {
      this.activeElement = element;
    }


    /*===== Menu methods =====*/
    bindEvents() {
      this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
  
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
  
      const openDetailsElement = event.target.closest('details[open]');
      if(!openDetailsElement) return;
  
      openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }

  
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.has-submenu');
      const isOpen = detailsElement.hasAttribute('open');
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  
      function addTrapFocus() {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
      }


      if (detailsElement === this.mainDetailsToggle) {
        if(isOpen) event.preventDefault();
        isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
      } else {
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          parentMenuElement && parentMenuElement.classList.add('submenu-open');
          !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
      }
    }
  
    openMenuDrawer(summaryElement) {
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  
    closeMenuDrawer(event, elementToFocus = false) {
      if (event === undefined) return;
  
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
        submenu.classList.remove('submenu-open');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  
    onFocusOut(event) {
      setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
      });
    }
  
    onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
  
    closeSubmenu(detailsElement) {
      if(!detailsElement)
        return
      const parentMenuElement = detailsElement.closest('.submenu-open');
      parentMenuElement && parentMenuElement.classList.remove('submenu-open');
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      removeTrapFocus(detailsElement.querySelector('summary'));
      this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
      let animationStart;
  
      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }
  
        const elapsedTime = time - animationStart;
  
        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
          if (detailsElement.closest('details[open]')) {
            trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
          }
        }
      }
      window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('drawer-component', Drawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
